import {reducerAndActionsFor, connect} from '../../helpers/helpers'; //eslint-disable-line
import {api} from '@symbolic/lib'
import Cookies from 'js-cookie';

var domain = process.env.NODE_ENV === 'development' ? 'localhost' : 'symbolicframeworks.com';

//TODO handle invalid username/password
var tokenFor = async ({email, password}) => {
  var tokenResponse = await api.request({uri: '/auth/token', body: {email, password}});
  var token = tokenResponse.data.data.token;

  Cookies.set('sessionToken', token, {expires: 365, domain});

  return token;
};

//TODO handle invalid token, invalid user
var userFor = async ({token}) => {
  var userResponse = await api.request({uri: '/user-for-token', body: {token}});

  return userResponse.data.data.user;
};

var {reducer, actions} = reducerAndActionsFor('session', {
  logIn: async ({token, email, password}) => {
    token = token || await tokenFor({email, password});

    var user = await userFor({token});

    if (!user) {
      Cookies.remove('sessionToken', {domain});

      throw new Error();
    }

    return {isLoggedIn: true, user};
  },
  logOut: () => {
    Cookies.remove('sessionToken', {domain});

    return {isLoggedIn: false};
  },
  signUp: async ({email, password, firstName, lastName, accessCode}) => {
    //create user
    await api.request({uri: '/sign-up', body: {firstName, lastName, email, password, accessCode}});

    //logIn
    var token = await tokenFor({email, password});
    var user = await userFor({token});

    return {isLoggedIn: true, user};
  },
  updateMyAccount: async ({email, password, firstName, lastName}) => {
    //create user
    await api.update('user', {props: {email, firstName, lastName}});

    var user = await userFor({token: Cookies.get('sessionToken')});

    return {isLoggedIn: true, user};
  },
});

var {logIn, signUp, logOut, updateMyAccount} = actions;

export default reducer;
export {logIn, signUp, logOut, updateMyAccount};
